import { Grid } from "@mui/material";

const FeeDetails = (_props) => {
    const { candidateData, isFeeExempted, className } = _props
    return (
        <fieldset className={`${className}--fieldset`}>
            <legend className={`${className}--legend`}>
                Fee Details
            </legend>
            {/* for web preview */}
            <div className="print-web">
                <Grid container spacing={1} className="print-display">
                    {/* <div className="print-details d-flex">
                          <div className="w-70">
                            <p className="final-preview--text">Application Fee</p>
                          </div>
                          <div className="w-30">
                            <p className="final-preview--subText text-red">
                              Fee Exempted
                            </p>
                          </div>
                        </div> */}
                    <Grid item lg={4} md={4} sm={4} xs={12}>
                        <div className={`${className}--feeDetailBox`}>
                            <p>Bank Reference Number</p>
                            <span>
                                {!isFeeExempted
                                    ? candidateData?.bank_ref_no
                                        ? candidateData?.bank_ref_no
                                        : "-"
                                    : "NA"}
                            </span>
                        </div>
                    </Grid>
                    <Grid item lg={4} md={4} sm={4} xs={12}>
                        <div className={`${className}--feeDetailBox custom-rht2`}>
                            <p>Transaction Date</p>
                            <span>
                                {!isFeeExempted
                                    ? candidateData?.transaction_date
                                        ? candidateData?.transaction_date
                                        : "-"
                                    : "NA"}
                            </span>
                        </div>
                    </Grid>
                    <Grid item lg={4} md={4} sm={4} xs={12}>
                        <div className={`${className}--feeDetailBox custom-rht2`}>
                            <p>Application Fee</p>
                            <span>
                                &#8377;
                                {(candidateData?.exam_fee || 0).toFixed(2)}
                            </span>
                        </div>
                    </Grid>
                    <Grid item lg={4} md={4} sm={4} xs={12}>
                        <div className={`${className}--feeDetailBox custom-rht2`}>
                            <p>Processing Fee</p>
                            <span>
                                &#8377;{" "}
                                {(candidateData?.exam_service_charge || 0).toFixed(2)}
                            </span>
                        </div>
                    </Grid>
                    <Grid item lg={4} md={4} sm={4} xs={12}>
                        <div className={`${className}--feeDetailBox custom-rht2`}>
                            <p>Total Amount Payable</p>
                            <span>
                                &#8377;{" "}
                                {((candidateData?.exam_fee + candidateData?.exam_service_charge) || 0).toFixed(2)}
                            </span>
                        </div>
                    </Grid>
                    <Grid item lg={4} md={4} sm={4} xs={12}>
                        <div className={`${className}--feeDetailBox custom-rht2`}>
                            <p>Status</p>
                            <span
                                className={
                                    candidateData?.payment_status
                                        ? isFeeExempted
                                            ? "text-red"
                                            : candidateData?.payment_status === "Success"
                                                ? "text-green"
                                                : "text-red"
                                        : ""
                                }
                            >
                                {candidateData?.payment_status
                                    ? isFeeExempted
                                        ? "Fee Exempted"
                                        : candidateData?.payment_status === "Success"
                                            ? "Paid"
                                            : "Failed"
                                    : "-"}
                            </span>
                        </div>
                    </Grid>
                </Grid>
            </div>
            {/* for print preview */}
            <div className="print-view">
                <div className="d-flex j-btw">
                    {/* <div className="print-details d-flex">
                        <div className="w-70">
                          <p className="final-preview--text">Application Fee</p>
                        </div>
                        <div className="w-30">
                          <p className="final-preview--subText text-red">
                            Fee Exempted
                          </p>
                        </div>
                      </div> */}
                    <div className={`${className}--feeDetailBox`}>
                        <p>Bank Reference Number</p>
                        <span>
                            {!isFeeExempted
                                ? candidateData?.bank_ref_no
                                    ? candidateData?.bank_ref_no
                                    : "-"
                                : "NA"}
                        </span>
                    </div>
                    <div className={`${className}--feeDetailBox`}>
                        <p>Transaction Date</p>
                        <span>
                            {!isFeeExempted
                                ? candidateData?.transaction_date
                                    ? candidateData?.transaction_date
                                    : "-"
                                : "NA"}
                        </span>
                    </div>
                    <div className={`${className}--feeDetailBox`}>
                        <p>Application Fee</p>
                        <span>
                            &#8377;
                            {(candidateData?.exam_fee || 0).toFixed(2)}
                        </span>
                    </div>
                    <div className={`${className}--feeDetailBox`}>
                        <p>Processing Fee</p>
                        <span>
                            &#8377;{" "}
                            {(candidateData?.exam_service_charge || 0).toFixed(2)}
                        </span>
                    </div>
                    <div className={`${className}--feeDetailBox`}>
                        <p>Total Amount Payable</p>
                        <span>
                            &#8377;{" "}
                            {((candidateData?.exam_fee + candidateData?.exam_service_charge) || 0).toFixed(2)}
                        </span>
                    </div>
                    <div className={`${className}--feeDetailBox`}>
                        <p>Status</p>
                        <span
                            className={
                                candidateData?.payment_status
                                    ? isFeeExempted
                                        ? "text-red"
                                        : candidateData?.payment_status === "Success"
                                            ? "text-green"
                                            : "text-red"
                                    : ""
                            }
                        >
                            {candidateData?.payment_status
                                ? isFeeExempted
                                    ? "Fee Exempted"
                                    : candidateData?.payment_status === "Success"
                                        ? "Paid"
                                        : "Failed"
                                : "-"}
                        </span>
                    </div>
                </div>
            </div>
        </fieldset>
    )
}

export default FeeDetails;